import { render, staticRenderFns } from "./SelectModuleView.vue?vue&type=template&id=514d45f4&"
import script from "./SelectModuleView.vue?vue&type=script&lang=js&"
export * from "./SelectModuleView.vue?vue&type=script&lang=js&"
import style0 from "./SelectModuleView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports